import { OptionItem, Section, TextBoxOption } from './TextSection';
import { SectionBase } from './SectionBase';
import { StateManager } from '../../store/StateManager';

export class TextBoxSection extends SectionBase {
  public options: TextBoxOption[] = [];
  constructor(section: Section) {

    super(section);
    this.options = section.options as TextBoxOption[]
  }

  private createInputElement(option: TextBoxOption): HTMLElement {
    const container = document.createElement('div');
    container.className = 'textbox-input-container';
    container.style.fontFamily = 'inherit'
    if (option.labelMaxWidth && Number(option.labelMaxWidth)) {
      const stateManger = StateManager.getInstance();
      const state = stateManger.getState();
      container.style.width = `calc(${Number(option.labelMaxWidth)}% - 2px)`;
    }
    else {
      container.style.width = `calc(100% - 2px)`;
    }
    if (option.showLabel) {
      const label = document.createElement('label');
      label.textContent = option.label;
      label.title = option.label;
      label.style.fontFamily = 'inherit'
      if (option.labelMaxWidth && Number(option.labelMaxWidth))
        label.style.whiteSpace = 'normal';
      container.appendChild(label);
    }

    const input = document.createElement('input');
    input.type = 'text';
    input.value = option.correctValue || '';
    input.placeholder = '';
    input.className = 'textbox-input';
    input.style.width = `calc(100% - 2px)`;
    input.style.border = '1px solid black';
    input.onchange = (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      option.correctValue = (e.target as HTMLInputElement).value;
      this.onChange(this.options);
    };
    input.addEventListener('keydown', (e) => {
      e.stopImmediatePropagation();
      e.stopPropagation();
    });
    container.appendChild(input);
    return container;
  }

  render(): HTMLDivElement {
    const wrapper = document.createElement('div');
    wrapper.classList.add('wrapper');

    const container = document.createElement('div');
    container.classList.add('section', 'textbox-section');

    this.options.forEach(option => {
      container.appendChild(this.createInputElement(option));
    });

    if (this.selected) {
      container.classList.add('selected');
    }

    wrapper.appendChild(container);
    return wrapper;
  }

  onChange(options: TextBoxOption[]) {
    //update state with options
    const stateManger = StateManager.getInstance();
    const oldState = stateManger.getState();
    const newSections = oldState.sections.map(section => {
      if (section.id === this.id) {
        section.options = options;
      }

      return section;
    });
    stateManger.setState({ sectionIds: [this.id], state: { ...oldState, sections: [...newSections] }, changeType: 'updateSection' });
  }

  clone() {
    return new TextBoxSection(this.toJSON());
  }
}
